// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list"}[chunkId] || chunkId) + "-" + {"583":"bdb48788517c4ffab4c9","702":"d3ed2b6038a2334ca187","715":"34dd6ecb43cd754170af"}[chunkId] + ".css";
};